module.exports = __webpack_public_path__ + "37b32c8adaf313529debad68f9e0ceb7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/pirate-hideaway-main.png
// module id = 2853
// module chunks = 0